const translations = {
    noResults: 'No results found'
};

export default translations;
